import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Typography,
    Button,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer,
    Paper,
    Pagination,
    Stack,
} from '@mui/material';

import { useAppContext } from '../context/AppContext';

const RAMappings = () => {
    const navigate = useNavigate();
    const { getRAMappings, raMappings, deleteRAMapping } = useAppContext();
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;
    const [filters, setFilters] = useState({
        ra_name: '',
        bri_id: '',
    });
    const [activeFilters, setActiveFilters] = useState({
        ra_name: '',
        bri_id: '',
    });

    useEffect(() => {
        getRAMappings(currentPage, pageSize, activeFilters);
    }, [currentPage, activeFilters]);
    console.log('RA Mappings from context: ', raMappings);

    const handleCreate = () => {
        navigate('/ra/create');
    };

    const handleFilterChange = (name) => (event) => {
        setFilters((prev) => ({ ...prev, [name]: event.target.value }));
    };

    const handleSearch = () => {
        setCurrentPage(1);
        setActiveFilters(filters);
    };

    const handleClearFilters = () => {
        const cleared = { ra_name: '', bri_id: '' };
        setFilters(cleared);
        setCurrentPage(1);
        setActiveFilters(cleared);
    };

    const handleEdit = (raMapping) => {
        navigate(`/ra/${raMapping.bri_id}/update`);
    };

    const handleDelete = async (raMapping) => {
        const confirmDelete = window.confirm(`Delete RA Mapping "${raMapping.ra_name}"?`);
        if (!confirmDelete) return;

        try {
            await deleteRAMapping(raMapping.bri_id);
            await getRAMappings(currentPage, pageSize, activeFilters);
        } catch (err) {
            console.error('Error deleting RA mapping:', err);
            alert('Error deleting RA mapping');
        }
    };

    const rows = Array.isArray(raMappings?.records) ? raMappings.records : [];
    const totalRecords = Number(raMappings?.total_records || rows.length || 0);
    const responsePageSize = Number(raMappings?.page_size || pageSize);
    const totalPages = Math.max(1, Math.ceil(totalRecords / responsePageSize));

    return (
        <>
            <Typography variant="h5">RA Mapping</Typography>
            <Stack direction="row" spacing={2} alignItems="center" sx={{ my: 2 }}>
                <TextField
                    label="RA Name"
                    value={filters.ra_name}
                    onChange={handleFilterChange('ra_name')}
                />
                <TextField
                    label="BRI ID"
                    value={filters.bri_id}
                    onChange={handleFilterChange('bri_id')}
                />
                <Button variant="outlined" onClick={handleSearch}>
                    Search
                </Button>
                <Button variant="outlined" onClick={handleClearFilters}>
                    Clear
                </Button>
                <Button variant="contained" onClick={handleCreate}>
                    Add New
                </Button>
            </Stack>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>RA Name</TableCell>
                            <TableCell>BRI ID</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((raMapping) => (
                                <TableRow key={raMapping.bri_id}>
                                    <TableCell>{raMapping.ra_name}</TableCell>
                                    <TableCell>{raMapping.bri_id}</TableCell>
                                    <TableCell>
                                        <Button variant="outlined" onClick={() => handleEdit(raMapping)} sx={{ mr: 1 }}>
                                            Modify
                                        </Button>
                                        <Button variant="outlined" color="error" onClick={() => handleDelete(raMapping)}>
                                            Delete
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Pagination
                count={totalPages}
                page={currentPage}
                onChange={(e, page) => setCurrentPage(page)}
                sx={{
                    mt: 2, display: 'flex', justifyContent: 'center',
                    '& .MuiPaginationItem-root': {
                        color: 'white',
                        backgroundColor: 'secondary.main',
                        '&.Mui-selected': {
                            backgroundColor: 'secondary.dark',
                        },
                        '&:hover': {
                            backgroundColor: 'secondary.light',
                        },
                    },
                }}
            />
        </>
    );
};

export default RAMappings;
